import { VehicleInspection } from '../types';

export function isPassFailInspection(inspection: VehicleInspection): boolean {
  return inspection.some(
    (item) => item.value === 'pass' || item.value === 'fail'
  );
}
